import { recordOf } from './type-checkers.js';
import { wrapCompositeType } from './util.js';
const wrappedTuple = wrapCompositeType(recordOf, { type: 'tuple' }, true);
function tuple([key, value]) {
    return wrappedTuple([key, value]);
}
export { tuple, };
//# sourceMappingURL=tuple.js.map